import React from 'react'
import Icon from './Icon'
import { colors } from '#app/theme/colors'
import { selectChannelIconName } from '#app/channel'

const ChannelIcon = ({ type }: { type: string }) => <Icon name={selectChannelIconName(type)} size={20} colorIcon={colors.white} colorBg={colors.green} />

export default ChannelIcon
